import {post} from '../../request'

/**
 * 获取资源列表
 * @param data
 * @returns {Promise<*>}
 */
export function getIndex(data) {
    return post("admin/resource.index/index", data)
}

/**
 * 修改标题
 * @param data
 * @returns {Promise<*>}
 */
export function editName(data) {
    return post("admin/resource.index/editTitle", data)
}

/**
 * 修改分类
 * @param data
 * @returns {Promise<*>}
 */
export function editResCat(data) {
    return post("admin/resource.index/moveCat", data)
}

/**
 * 获取资源列表
 * @param data
 * @returns {Promise<*>}
 */
export function deleteRes(data) {
    return post("admin/resource.index/delete", data)
}

/**
 * 获取资源列表
 * @param data
 * @returns {Promise<*>}
 */
export function deleteResCat(data) {
    return post("admin/resource.index/index", data)
}

